import { DateTime } from 'luxon'
import SnowReportService from '@/modules/Resorts/Services/SnowReportService'
import FacilitiesServices from '@/modules/Resorts/Services/FacilitiesServices'
import { unifyPaginatedResponse } from '@/modules/Shared/Helpers/apiResponseHelper'

export default {
  methods: {
    async fetchFacilities(type) {
      const facilities = await unifyPaginatedResponse(
        FacilitiesServices.getResortFacilities,
        { resort_uuid: this.selectedResortUuid, q: `type:${type}` }
      )
      return this.filterFacilities(facilities || [], type)
    },
    filterFacilities(facilities, type) {
      const timeFilter = type === 'bikepark-trail' ? ['summer', 'always'] : ['winter', 'always']
      return facilities.filter(facility =>
        !facility.timeofyear || timeFilter.includes(facility.timeofyear)
      )
    },
    async getSnowReportUpdatedAt() {
      const response = await SnowReportService.getSnowReport(this.selectedResortUuid)
      const report = this.normalizeSnowReportResponse(response)
      return this.getUpdatedTimestamp(report)
    },
    normalizeSnowReportResponse(response) {
      if (!response) {
        return null
      }
      if (Array.isArray(response.data)) {
        return response.data[0] || null
      }
      return response
    },
    getUpdatedTimestamp(report) {
      if (!report || !report.updated) {
        return null
      }
      return report.updated 
    },
    isOutdated(timestampSeconds, maxDays) {
      if (!timestampSeconds) {
        return false
      }
      const timestamp = DateTime.fromSeconds(timestampSeconds)
      return DateTime.now().diff(timestamp, 'days').days > maxDays
    }
  }
}

